// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__lulux","title":"Header_title__3DKr4","rightSection":"Header_rightSection__3lJyU"};